import type { BusinessDocumentType } from '~domains/partner-application/entities/application/model';

type BusinessDocumentSection = {
  documentType: BusinessDocumentType;
  title: string;
  description?: string;
  required: boolean;
  multiple: boolean;
};

export const businessDocumentSections: BusinessDocumentSection[] = [
  {
    documentType: 'BUSINESS_PERMIT',
    title: "Business Permit / Mayor's Permit",
    required: true,
    multiple: false,
  },
  {
    documentType: 'BIR_CERTIFICATE_OR_FORM2303',
    title: 'BIR Certificate of Registration or Form 2303',
    required: true,
    multiple: false,
  },
  {
    documentType: 'DTI_CERTIFICATE',
    title: 'DTI Certificate of Business Name Registration',
    required: true,
    multiple: false,
  },
  {
    documentType: 'OTHER',
    title: 'Other supporting documents (if any)',
    description:
      'Lease contract, utility bills, barangay clearance, supplier/customer contracts, etc.',
    required: false,
    multiple: true,
  },
];

export const FILE_OPTIONS = {
  allowedExtensions: ['pdf', 'jpeg', 'jpg', 'png'],
  maxSize: 10 * 1024 * 1024, // 10MB
};
